import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { isFolderUnderArchiveRoot } from 'owa-mail-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { isDeletedItemsFolderFromAnyMailbox } from 'owa-mail-store';
import { PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID, } from 'owa-folders';
/**
 * Get properties required for completing empty folder action
 * @param folder the folder to be emptied
 */
export default function getEmptyFolderHelperProperties(folder) {
    if (!folder) {
        throw new Error('Folder should not be null at getEmptyFolderHelperProperties');
    }
    var emptyFolderHelperProperties = {};
    var isFolderUnderArchiveMbx = isFolderUnderArchiveRoot(folder.FolderId.Id);
    if (isFolderUnderArchiveMbx) {
        // Bulk actions notifications (or any kind of notification) are not supported for folder from Archive MBX
        emptyFolderHelperProperties.shouldSupportBulkActions = false;
        emptyFolderHelperProperties.treeType = 'archiveFolderTree';
        emptyFolderHelperProperties.deletedItemsFolderId = folderNameToId(ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID);
    }
    else {
        emptyFolderHelperProperties.shouldSupportBulkActions = isMailFeatureEnabled('tri-bulkActionNotification');
        emptyFolderHelperProperties.treeType = 'primaryFolderTree';
        emptyFolderHelperProperties.deletedItemsFolderId = folderNameToId(PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID);
    }
    emptyFolderHelperProperties.isFolderDeletedItemsFolder = isDeletedItemsFolderFromAnyMailbox(folder.FolderId.Id);
    return emptyFolderHelperProperties;
}
//# sourceMappingURL=emptyFolderHelper.js.map